// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"167":"8b681e92","633":"5452ab96","642":"6b8b497f","791":"35f3b045","925":"570b1b3b","962":"e542e4c7"}[chunkId] + ".css";
};